import Facets from './Facets'

export default Facets
